export default __webpack_public_path__ + "static/media/workplaceBgr1.220c711b.jpg";